import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import EventsScreen from '../../Event/EventsScreen';
import DocumentsScreen from '../../DocumentsScreen';
import ProfilesScreen from '../../ProfilesScreen';
import OrganizersScreen from '../../Organizer/OrganizersScreen';
import MarketingPersonsScreen from '../../MarketingPersons/MarketingPersonsScreen';
import MarketingPersonDetailsScreen from '../../MarketingPersons/MarketingPersonDetailsScreen';
import PaymentsReportScreen from '../../MarketingPersons/PaymentsReportScreen';
import PayoutsListScreen from '../../MarketingPersons/PayoutsListScreen';
import PayoutDetailsScreen from '../../MarketingPersons/PayoutDetailsScreen';
import AppLayout from '../AppLayout';
import LogIn from '../../LogIn';
import ConfirmReceipt from '../../ConfirmReceipt';
import InvoiceReceipt from '../../InvoiceReceipt';
import RequireToken from '../RequireAuth';
import OrganizerTransactionListScreen from '../../Organizer/OrganizerTransactionListScreen';
import EventTransactionListScreen from '../../Event/EventTransactionListScreen';
import OrganizerRequestListScreen from '../../Organizer/OrganizerRequestListScreen';
import TransactionListScreen from '../../Transaction/TransactionListScreen';
import StaticOtpScreen from '../../StaticOtpScreen';
import OtpBypassScreen from '../../OtpBypassScreen';
import RobotSmsPolicyScreen from '../../RobotSmsPolicyScreen';

const Root: React.FC = () => {
  return (<>
    <AppLayout>
      <Routes>
        <Route path="/login" element={<LogIn />} />
        <Route path="/confirm-receipt" element={<ConfirmReceipt/>} />
        <Route path="/invoice-receipt" element={<InvoiceReceipt/>} />
        <Route element={<RequireToken />}>
          <Route path="/" element={<Navigate to="/events/all" replace />} />
          <Route path="/events/:type" element={<EventsScreen />} />
          <Route path="/events/:id/transaction/list/:type" element={<EventTransactionListScreen />} />
          <Route path="/profiles" element={<ProfilesScreen/>} />
          <Route path="/transactions/:type" element={<TransactionListScreen/>} />
          <Route path="/organizers/:type" element={<OrganizersScreen/>} />
          <Route path="/organizers/request/list" element={<OrganizerRequestListScreen/>} />
          <Route path="/organizers/:id/transaction/list/:type" element={<OrganizerTransactionListScreen />} />
          <Route path="/documents" element={<DocumentsScreen/>} />
          <Route path="/marketing-persons/payments" element={<PaymentsReportScreen/>} />
          <Route path="/marketing-persons/payouts" element={<PayoutsListScreen/>} />
          <Route path="/marketing-persons/payouts/:payoutId" element={<PayoutDetailsScreen/>} />
          <Route path="/marketing-persons/:id/details" element={<MarketingPersonDetailsScreen/>} />
          <Route path="/marketing-persons/:type" element={<MarketingPersonsScreen/>} />
          <Route path="/static-otp" element={<StaticOtpScreen/>} />
          <Route path="/captcha-bypass" element={<OtpBypassScreen/>} />
          <Route path="/robot-sms-policy" element={<RobotSmsPolicyScreen/>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>

      </Routes>
    </AppLayout>
</>
  );
};

export default Root;
